<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-05-15 19:05:42
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<!--
Author: jiangli
Date: 2024-04-19
Desc: 常见问题
 -->
<template>
    <div v-if="!$util.belongHx()" class="common-question-contain">
        <div v-if="warningHtml" class="flex hcenter c_333">
            <img src="../../assets/img/red-tip.png" class="h18 mr5" />
            <span class="fs18">温馨提示</span>
        </div>
        <div
            v-if="warningHtml"
            :class="'mt10 lin26 c_333 fs14 ' + (datas.length > 0 ? 'mb30' : '')"
            v-html="warningHtml"
        ></div>
        <div v-if="datas.length" class="common-question-content">
            <img src="../../assets/img/red-questionMark.png" class="h18 mr5" />
            <span class="common-question-title">常见问题</span>
        </div>
        <div v-for="(item, index) in datas" :key="index" class="question-title-answer">
            <div class="question-title" v-on:click="questionAnswerShow(index)">
                {{ item.title }}
            </div>
            <div v-show="item.showFlag" class="question-answer" v-html="item.answer"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterQuestions",
    props: {
        commonQuestion: {
            type: Array,
            default: () => {
                return [];
            }
        },
        warningHtml: {
            type: String,
            default: () => {
                return "";
            }
        }
    },
    data() {
        return {
            datas: []
        };
    },
    watch: {
        commonQuestion(value) {
            this.datas = value;
        }
    },
    mounted() {
        this.datas = this.commonQuestion;
    },
    methods: {
        // 方法定义
        questionAnswerShow(index) {
            this.datas[index].showFlag = !this.commonQuestion[index].showFlag;
        }
    }
};
</script>

<style lang="scss" scoped>
.common-question-contain {
    padding: 0 20px 20px;
    .common-question-content {
        display: flex;
        align-items: center;
        .circle-tips {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background-color: #e60000;
        }
        .common-question-title {
            margin-left: 5.8px;
            font-size: 18px;
            color: #333333;
        }
    }
    .question-title-answer {
        padding-top: 5px;
        .question-title {
            padding: 5px 0;
            color: #999999;
            cursor: pointer;
        }
        .question-answer {
            padding: 5px 0;
            color: #333333;
        }
    }
}
</style>
